import React from 'react';
import { motion } from 'framer-motion';
import { Award, Linkedin, Sparkles, UserCheck, BadgeCheck } from 'lucide-react';
interface Cert {
  name: string;
  // Short monogram shown inside the seal (acronyms get a monogram, others get an icon)
  monogram?: string;
  icon?: React.ReactNode;
}
const certs: Cert[] = [{
  name: 'Certified Professional Resume Writer (CPRW)',
  monogram: 'CPRW'
}, {
  name: 'Nationally Certified Resume Writer (NCRW)',
  monogram: 'NCRW'
}, {
  name: 'Certified Advanced Resume Writer (CARW)',
  monogram: 'CARW'
}, {
  name: 'Certified Employment Interview Professional (CEIP)',
  monogram: 'CEIP'
}, {
  name: 'Certified Executive Resume Master (CERM)',
  monogram: 'CERM'
}, {
  name: 'Certified Career Management Coach (CCMC)',
  monogram: 'CCMC'
}, {
  name: 'Certified LinkedIn Profile Writer',
  icon: <Linkedin className="w-6 h-6" data-id="element-56" />
}, {
  name: 'Certified Personal Branding Strategist',
  icon: <Sparkles className="w-6 h-6" data-id="element-57" />
}, {
  name: 'Certified Professional Career Coach',
  icon: <UserCheck className="w-6 h-6" data-id="element-58" />
}, {
  name: 'Professional Association of Resume Writers & Career Coaches Member',
  monogram: 'PARW'
}];
function CertSeal({
  cert
}: {
  cert: Cert;
}) {
  return <div className="relative flex-shrink-0" data-id="element-59">
      {/* Outer ring */}
      <div className="w-16 h-16 rounded-full bg-navy-900 flex items-center justify-center ring-2 ring-gold/40 ring-offset-2 ring-offset-white" data-id="element-60">
        {/* Inner seal */}
        <div className="w-12 h-12 rounded-full border border-gold/50 flex items-center justify-center text-gold" data-id="element-61">
          {cert.monogram ? <span className="text-[11px] font-bold tracking-tight font-serif-display" data-id="element-62">
              {cert.monogram}
            </span> : cert.icon}
        </div>
      </div>
      {/* Verified tick */}
      <BadgeCheck className="absolute -bottom-1 -right-1 w-5 h-5 text-gold bg-white rounded-full" data-id="element-63" />
    </div>;
}
export function Certifications() {
  return <section className="py-20 bg-navy-50 border-y border-navy-100" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <span className="inline-flex items-center gap-2 text-gold font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-67">
            <Award className="w-4 h-4" data-id="element-68" /> Credentials
          </span>
          <h2 className="text-2xl md:text-3xl font-serif-display font-bold text-navy-900 mb-4" data-id="element-69">
            Industry-Recognized Certifications
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-70">
            Our team holds the highest standard of certifications in the
            executive branding and career management industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-71">
          {certs.map((cert, index) => <motion.div key={cert.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index % 3 * 0.08
        }} className="flex items-center gap-4 bg-white p-5 rounded-sm shadow-sm border border-gray-100 hover:border-gold/40 hover:shadow-md transition-all" data-id="element-72">
              <CertSeal cert={cert} data-id="element-73" />
              <span className="text-navy-900 font-semibold text-sm leading-snug" data-id="element-74">
                {cert.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}